import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../records/server/serverUtility";

export const vsName = "slotTrakMachinesServer";

export class SlotTrakServerAdapter {
  static $inject = [serverUtilityName];

  constructor(private readonly serverUtility: ServerUtility) {}
}
